import React from "react";

import { connect } from "react-redux";
import {
  editarEmpresa,
  guardarEmpresa,
} from "../../components/empresas/EmpresaService";
import {
  getConfiguracionCorreo,
  guardarConfiguracionCorreo,
} from "../../components/correo/CorreoService";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

class Configuracion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      host: "",
      puerto: "",
      replyTo: "",
      alias: "",
      disponible: false,
      username: "",
      contraseña: "",
      mecanicoAutenticacion: "",
      authEnabled: false,
      sslEnabled: false,
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "",
      confirmContraseña: "",
      openPantallaCarga: false,
      validated: false,
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkedChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  componentDidMount = () => {
    getConfiguracionCorreo().then((res) => {
      if (!res.error) {
        this.setState({
          host: res.datos.host,
          puerto: res.datos.puerto,
          replyTo: res.datos.replyTo,
          alias: res.datos.alias,
          disponible: res.datos.disponible,
          username: res.datos.username,
          contraseña: res.datos.contraseña,
          mecanicoAutenticacion: res.datos.mecanicoAutenticacion,
          authEnabled: res.datos.authEnabled,
          sslEnabled: res.datos.sslEnabled,
          confirmContraseña: res.datos.contraseña,
        });
      }
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ openPantallaCarga: true });
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ validated: true, openPantallaCarga: false });
    } else {
      this.setState({ validated: true });
      const json = {
        host: this.state.host,
        puerto: this.state.puerto,
        replyTo: this.state.replyTo,
        alias: this.state.alias,
        disponible: this.state.disponible,
        username: this.state.username,
        contraseña: this.state.contraseña,
        mecanicoAutenticacion: this.state.mecanicoAutenticacion,
        authEnabled: this.state.authEnabled,
        sslEnabled: this.state.sslEnabled,
      };

      if (json.contraseña !== this.state.confirmContraseña) {
        this.setState({
          mensajeFlashSeverity: "danger",
          mensajeFlash: "Las contraseñas no coinciden ",
          mostrarMensajeFlash: true,
          openPantallaCarga: false,
        });
      } else {
        guardarConfiguracionCorreo(json).then((response) => {
          if (!response.error) {
            this.setState({ mensajeFlashSeverity: "success" });
          } else {
            this.setState({ mensajeFlashSeverity: "danger" });
          }
          this.setState({
            mensajeFlash: response.mensaje,
            mostrarMensajeFlash: true,
            openPantallaCarga: false,
          });
        });
      }
    }
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  render() {
    return (
      <div>
        <header className="component-header">
          <div className="page-container">
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">Configuración de Correo</h1>
                <p className="page-description">
                  Desde este menú puede configurar el servidor de correo
                  utilizado para el envío de notificaciones
                </p>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="page-container">
        <form onSubmit={this.handleSubmit} className="form container-sm">
          <span className="form-subtitle">Configuración de correo</span>

          <div className="form-group__inline">
            <div className="form-group">
              <input
                type="text"
                name="host"
                id="host"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.host}
                required
              />
              <label htmlFor="host" className="form-label">
                Host
              </label>
            </div>

            <div className="form-group">
              <input
                type="text"
                name="puerto"
                id="puerto"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.puerto}
                required
              />
              <label htmlFor="puerto" className="form-label">
                Puerto
              </label>
            </div>

            <div className="form-group">
              <input
                type="email"
                name="replyTo"
                id="replyTo"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.replyTo}
                required
              />
              <label htmlFor="replyTo" className="form-label">
                Responder a
              </label>
            </div>

            <div className="form-group">
              <input
                type="text"
                name="alias"
                id="alias"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.alias}
                required
              />
              <label htmlFor="alias" className="form-label">
                Alias
              </label>
            </div>

            <div className="form-group">
              <label className="check-label">
                <input
                  type="checkbox"
                  name="disponible"
                  checked={this.state.disponible}
                  onChange={this.checkedChange}
                  className="form-check"
                />
                Disponible
              </label>
            </div>
          </div>

          <span className="form-subtitle">Autenticación</span>

          <div className="form-group__inline">
            <div className="form-group">
              <input
                type="text"
                name="username"
                id="username"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.username}
                required
              />
              <label htmlFor="username" className="form-label">
                Usuario
              </label>
            </div>

            <div className="form-group">
              <input
                type="text"
                name="mecanicoAutenticacion"
                id="mecanicoAutenticacion"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.mecanicoAutenticacion}
                disabled={!this.state.authEnabled}
                required
              />
              <label htmlFor="mecanicoAutenticacion" className="form-label">
                Mecanismos de autenticación
              </label>
            </div>

            <div className="form-group">
              <input
                type="password"
                name="contraseña"
                id="contraseña"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.contraseña}
                disabled={!this.state.authEnabled}
                required
              />
              <label htmlFor="contraseña" className="form-label">
                Contraseña
              </label>
            </div>

            <div className="form-group">
              <input
                type="password"
                name="confirmContraseña"
                id="confirmContraseña"
                className="form-input"
                onChange={this.handleChange}
                value={this.state.confirmContraseña}
                disabled={!this.state.authEnabled}
                required
              />
              <label htmlFor="confirmContraseña" className="form-label">
                Confirmar contraseña
              </label>
            </div>

            <div className="form-group">
              <label className="check-label">
                <input
                  type="checkbox"
                  name="authEnabled"
                  checked={this.state.authEnabled}
                  onChange={this.checkedChange}
                  className="form-check"
                />
                Habilitar autenticación
              </label>
            </div>

            <div className="form-group">
              <label className="check-label">
                <input
                  type="checkbox"
                  name="sslEnabled"
                  checked={this.state.sslEnabled}
                  onChange={this.checkedChange}
                  className="form-check"
                  disabled={!this.state.authEnabled}
                />
                Habilitar SSL
              </label>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-medium btn-primary">
              Guardar
            </button>
          </div>
        </form>
          </div>
        </div>
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarEmpresa: (value) => dispatch(guardarEmpresa(value)),
  editarEmpresa: (value) => dispatch(editarEmpresa(value)),
});

export default connect(null, mapDispatchToProps)(Configuracion);
